"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var priceInputStyles = makeStyles_1.default(function () { return ({
    currency: {
        paddingLeft: 7,
        marginRight: 'unset',
    },
}); }, { name: 'GqlCheckout_InStorePaymentForm_PriceInput' });
exports.default = priceInputStyles;
